// frontend/src/pages/PayrollDone/usePayrollSettings.ts
// React Query hook for company-wide payroll settings.
// Reusable from any payroll page that needs the posting bank, etc.

import { useQuery } from "@tanstack/react-query";
import { API_URL, authHeaders } from "./helpers";
import type { PayrollSettings } from "./types";

/**
 * Fetches company payroll settings.
 * Returns null on a non-OK response (settings are optional).
 */
export function usePayrollSettings() {
  return useQuery<PayrollSettings | null>({
    queryKey: ["payroll-settings"],
    queryFn: async function () {
      const res = await fetch(API_URL + "/api/v1/payroll/settings", {
        headers: authHeaders(),
      });
      if (!res.ok) return null;
      return await res.json();
    },
    refetchOnWindowFocus: false,
  });
}